import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey } from '../../query/types';

const redeemableTicketsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'redeemableTickets'] as const,
    export: [...keys, 'redeemableTickets', 'export'] as const,
    options: [...keys, 'redeemableTickets', 'options'] as const,
  });

export { redeemableTicketsKeys };
